import * as Utils from '@ext/index';
import { Buscador } from './Buscador';
export { Buscador };

export class Estados {

    constructor( id: string, descripcion: string ) {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Estados {

        if ( id === this.Respondida.Id )
            return this.Respondida;
        else if ( id === this.NoRespondida.Id )
            return this.NoRespondida;


        return new Estados( id, id );
    }

    public static readonly NoRespondida: Estados = new Estados( 'UNANSWERED', 'No respondida' );
    public static readonly Respondida: Estados = new Estados( 'ANSWERED', 'Respondida' );

    public static Options: Array<Estados> = [
        Estados.Respondida,
        Estados.NoRespondida,

    ];

    public static Filter = [
        { Id: 0, Nombre: 'Todos', Valor: [] },
        { Id: 1, Nombre: Estados.Respondida.Descripcion, Valor: [Estados.Respondida] },
        { Id: 2, Nombre: Estados.NoRespondida.Descripcion, Valor: [Estados.NoRespondida] },
    ];

    public get esRespondida(): boolean { return this.Id === Estados.Respondida.Id; }
    public get esNoRespondida(): boolean { return this.Id === Estados.NoRespondida.Id; }

}